import React from 'react'
import "./About_card.css"

function About_card() {
    return (
        <>
            <section className='About_card margin_section'>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className=" col-xl-3 col-md-4 col-sm-6 mb-3">
                            <div className='About_card_holder'>
                                <div className="img_holder">
                                    <img src="/assets/images/about/about-card/img1.png" alt="" className='About_img' />
                                </div>
                                <div className="text_holder">
                                    <h4>Customers</h4>
                                    <h6>Find Services Easily</h6>
                                    <p>Browse trusted vendors, post your requirements, and get quick responses for home, office, or construction needs.</p>
                                </div>
                            </div>
                        </div>

                        <div className=" col-xl-3 col-md-4 col-sm-6 mb-3">
                            <div className='About_card_holder'>
                                <div className="img_holder">
                                    <img src="/assets/images/about/about-card/img2.png" alt="" className='About_img' />
                                </div>
                                <div className="text_holder">
                                    <h4>Vendors</h4>
                                    <h6>Grow Your Business</h6>
                                    <p>List your shop, showcase products/services, receive direct customer inquiries, and access leads from your city.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-xl-3 col-md-4 col-sm-6 mb-3">
                            <div className='About_card_holder'>
                                <div className="img_holder">
                                    <img src="/assets/images/about/about-card/img3.png" alt="" className='About_img' />
                                </div>
                                <div className="text_holder">
                                    <h4>Experts</h4>
                                    <h6>Share Your Skills</h6>
                                    <p>Create a professional profile, offer consultations, and be listed as a verified expert in plumbing, design, planning & more.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default About_card